import React from 'react';
import { DynamicIcon } from '../icons/DynamicIcon';

interface TabConsumoEstimadoProps {
  eventoData: {
    numeroConvidados: number;
    nivelConsumo: string;
    bartenders: number;
    assistentes: number;
    margemLucro: number;
  };
  setEventoData: React.Dispatch<React.SetStateAction<any>>;
}

const TabConsumoEstimado: React.FC<TabConsumoEstimadoProps> = ({ eventoData, setEventoData }) => {
  const niveisConsumo = [
    { valor: 'baixo', label: 'Baixo', drinks: 1.5, descricao: '1,5 drinks por pessoa' },
    { valor: 'medio', label: 'Médio', drinks: 3, descricao: '3 drinks por pessoa' },
    { valor: 'alto', label: 'Alto', drinks: 5, descricao: '5 drinks por pessoa' }
  ];

  const calcularStaff = () => {
    const convidados = eventoData.numeroConvidados || 0;
    const bartenders = Math.max(1, Math.ceil(convidados / 50)); // 1 bartender para cada 50 pessoas
    const assistentes = Math.ceil(convidados / 100); // 1 assistente para cada 100 pessoas
    return { bartenders, assistentes };
  };

  const staffSugerido = calcularStaff();

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-bold mb-6 flex items-center">
        <DynamicIcon name="glasses" size={24} className="mr-2 text-blue-600" />
        Consumo Estimado e Staff
      </h2>

      <div className="space-y-6">
        {/* Nível de Consumo */}
        <div>
          <h3 className="font-semibold mb-3">Nível de Consumo</h3>
          <div className="space-y-2">
            {niveisConsumo.map(nivel => (
              <label key={nivel.valor} className="flex items-center gap-3 p-3 border rounded hover:bg-gray-50 cursor-pointer">
                <input
                  type="radio"
                  name="nivelConsumo"
                  value={nivel.valor}
                  checked={eventoData.nivelConsumo === nivel.valor}
                  onChange={(e) => setEventoData({...eventoData, nivelConsumo: e.target.value})}
                  className="text-blue-600"
                />
                <div>
                  <span className="font-medium">{nivel.label}</span>
                  <span className="text-sm text-gray-600 ml-2">({nivel.descricao})</span>
                </div>
              </label>
            ))}
          </div>
        </div>

        {/* Cálculo de Staff */}
        <div>
          <h3 className="font-semibold mb-3">Equipe de Trabalho</h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Bartenders 
                <span className="text-gray-500 ml-1">(sugerido: {staffSugerido.bartenders})</span>
              </label>
              <input
                type="number"
                min="1"
                className="w-full border rounded px-3 py-2"
                value={eventoData.bartenders}
                onChange={(e) => setEventoData({...eventoData, bartenders: parseInt(e.target.value) || 1})}
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Assistentes
                <span className="text-gray-500 ml-1">(sugerido: {staffSugerido.assistentes})</span>
              </label>
              <input
                type="number"
                min="0"
                className="w-full border rounded px-3 py-2"
                value={eventoData.assistentes}
                onChange={(e) => setEventoData({...eventoData, assistentes: parseInt(e.target.value) || 0})}
              />
            </div>
          </div>
        </div>

        {/* Margem de Lucro */}
        <div>
          <label className="block text-sm font-medium mb-1">Margem de Lucro (%)</label>
          <input
            type="number"
            min="0"
            className="w-full border rounded px-3 py-2"
            value={eventoData.margemLucro}
            onChange={(e) => setEventoData({...eventoData, margemLucro: parseInt(e.target.value) || 0})}
          />
        </div>

        {/* Resumo */}
        <div className="bg-blue-50 p-4 rounded">
          <h4 className="font-semibold mb-2">Resumo do Consumo</h4>
          <p className="text-sm">
            Total de drinks estimados: {' '}
            <span className="font-bold">
              {Math.ceil(eventoData.numeroConvidados * niveisConsumo.find(n => n.valor === eventoData.nivelConsumo)?.drinks || 0)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TabConsumoEstimado;